import { get } from './RestUtils'
import Footprint from 'models/Footprint'
import Locale from 'models/Locale'
import Translation from 'models/Translation'
import Topic from 'models/Topic'
import Market from 'models/Market'

export const getFootprint = (locale: string): Promise<Footprint> => {
    const url = `/data/footprint/${locale}.json`

    return get<Footprint>(url)
}

export const getLocales = (): Promise<Locale[]> => {
    const url = `/data/locales.json`

    return get<Locale[]>(url)
}

export const getMarkets = (locale: string): Promise<Market[]> => {
    const url = `/data/markets/${locale}.json`

    return get<Market[]>(url)
}

export const getTranslations = (locale: string): Promise<Translation> => {
    const url = `/data/translations/${locale}.json`

    return get<Translation>(url, {camelCaseKeys: false})
}

export const getTopics = (locale: string): Promise<Topic[]> => {
    const url = `/data/topics/${locale}.json`

    return get<Topic[]>(url)
}
